import * as React from 'react';
import logout from 'src/assets/logoutIcon';
import accoutSetting from 'src/assets/accountSetting';
import UserModel from 'src/model/user.model';
import switchAccount from 'src/assets/switchUserSidemenu';

import 'src/components/MobileMenu/MobileMenu.scss';
import {
  goToHome,
  goToAccount,
  goToOrders,
  goToLocations,
  goToCart,
  goToTracking,
  cartUrl,
  ordersUrl,
  trackingUrl,
  locationsUrl,
  accountUrl,
  goToSwitchAccount,
  invoicesUrl,
  goToInvoices,
  returnsUrl,
  goToReturns,
  goToLists,
  listsUrl
} from 'src/utils/navigation';
import returnIcon from 'src/assets/returnIcon';
import env from 'src/shared/env';

interface IMobileMenuProps {
  signout: () => void;
  isLoggedIn: boolean;
  mounted: boolean;
  getCategories: () => void;
  handleCloseMenu: () => void;
  handleCloseAll: () => void;
  menuTitle: string;
  userData: UserModel;
  getUserData: () => void;
  specialUser: string;
  accountHasChanged: boolean;
  changeActiveAccountFlag(flag: boolean): void;
  changeActiveAccount(newAccountId: string, clientIdentity: string): void;
  t?: any;
  showSwitchAccounts: boolean;
}

interface IMobileMenuState {
  show: boolean;
  showCategories: boolean;
  subMenuTitle: string;
  subcategories: any;
  accountId: string;
  name: string;
}

class MobileMenu extends React.Component<IMobileMenuProps, IMobileMenuState> {
  constructor(props: any) {
    super(props);
    this.state = {
      show: false,
      showCategories: true,
      subMenuTitle: '',
      subcategories: [],
      accountId:
        this.props.userData && this.props.userData.accountId
          ? this.props.userData.accountId
          : '',
      name:
        this.props.userData && this.props.userData.sub
          ? this.props.userData.sub
          : ''
    };
  }

  public handleOpenMobileMenu = () => {
    if (!this.state.show) {
      window.scrollTo(0, 0);
    }
    this.setState(prevState => ({
      show: !prevState.show
    }));
  };

  public handleCloseMobileMenu = () => {
    this.setState(prevState => ({
      show: false
    }));
    window.scrollTo(0, 0);
  };

  public handleOpenSubMenu = () => {
    this.setState({
      showCategories: true
    });
  };

  public handleCloseSubMenu = () => {
    this.setState({
      showCategories: false
    });
  };

  private logOut = () => {
    this.props.signout();
    this.handleCloseMobileMenu();
    goToHome();
  };

  private redirect = (callback: () => void) => {
    this.handleCloseMobileMenu();
    callback();
  };

  public render() {
    const { t } = this.props;
    if (this.state.show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return (
      <div className="rp-mobile-menu">
        <div
          onClick={e => this.handleOpenMobileMenu()}
          className="rp-mobile-menu--button"
        >
          <button 
            className={`rpds ${
              !this.state.show ? 'rpds-menu' : 'rpds-close'
            } open-menu-icon`}
          />
        </div>
        {this.state.show && (
          <div
            // className="rp-mobile-menu--toogle"
            className={
              this.props.isLoggedIn
                ? 'rp-mobile-menu--toogle'
                : 'rp-mobile-menu--toogle rp-side-menu-height'
            }
          >
            <div className="rp-menu-width">
              {this.props.isLoggedIn && (
                <div className="rp-mobile-menu--account">
                  <i className="rpds-user sidemenu--avatar" />
                  <div>
                    <p className="rp-user-name">{this.props.userData.name}</p>
                    <p className="rp-account-id">
                      {this.props.userData.accountId}
                      {this.props.showSwitchAccounts ? (
                        <img
                          src={switchAccount}
                          alt="icon"
                          className="rp-switchMenu-icon"
                          onClick={goToSwitchAccount}
                        />
                      ) : null}
                    </p>
                  </div>
                </div>
              )}
              <div>
                {this.props.isLoggedIn && (
                  <a
                    href={accountUrl()}
                    className="rp-mobile-menu--menu-link-text"
                  >
                    <div
                      className="rp-mobile-menu--menu-link"
                      onClick={e => this.redirect(goToAccount)}
                    >
                      <span className="menu-link-icon">
                        <img
                          src={accoutSetting}
                          alt="Accout Setting"
                          className="sidemenu-icons"
                        />
                      </span>
                      {t('account.accountSettings')}
                    </div>
                  </a>
                )}
                {this.props.isLoggedIn && (
                  <div
                    className="rp-mobile-menu--menu-link"
                    onClick={this.logOut}
                  >
                    <span className="menu-link-icon">
                      <img
                        src={logout}
                        alt="Logout"
                        className="sidemenu-icons"
                      />
                    </span>
                    {t('common.logOut')}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default MobileMenu;
